import {
  Box,
  Typography,
  Stack,
  Link,
  Divider,
  Grid,
  TextField,
  Button,
  useTheme,
  useMediaQuery
} from '@mui/material';

import contactLady from '../assets/image/contact-lady.png';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>

      {/* ------------------------------------------------ */}
      {/*   COMPACT CONTACT SECTION (Centered + Stylish)   */}
      {/* ------------------------------------------------ */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#f3f4f6",
          py: { xs: 6, md: 8 },
          px: { xs: 2, md: 4 },
          textAlign: "center",
        }}
      >
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
          sx={{ maxWidth: 900, mx: "auto" }}
        >
          {/* LEFT TEXT + FORM */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ mb: 1, color: "#0f172a" }}
            >
              Have a Question About Our Services?
            </Typography>

            <Typography variant="body2" sx={{ mb: 3, color: "#4b5563" }}>
              Contact us for an obligation-free chat.
            </Typography>

            <Box sx={{ maxWidth: 340, mx: "auto" }}>
              <TextField
                fullWidth
                placeholder="Name"
                size="small"
                sx={{
                  mb: 1.5,
                  background: "#fff",
                  borderRadius: 1,
                }}
              />

              <TextField
                fullWidth
                placeholder="Mobile No."
                size="small"
                sx={{
                  mb: 2,
                  background: "#fff",
                  borderRadius: 1,
                }}
              />

              <Button
                fullWidth
                sx={{
                  fontWeight: 700,
                  borderRadius: 2,
                  border: '1px solid #ccc',
                  backgroundColor: '#FFB733',
                  color: '#000',
                  py: 1.2,
                  transition: 'all 0.3s ease',
                  boxShadow: 'none',

                  '&:hover': {
                    backgroundColor: '#e7c382ff',
                    color: '#fff',
                    boxShadow: '0px 6px 12px rgba(255, 177, 51, 0.4)',
                  },
                }}
              >
                Enquire Now
              </Button>

            </Box>
          </Grid>

          {/* RIGHT LADY IMAGE */}
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={contactLady} // replace with your image
              alt="Contact Support"
              sx={{
                width: { xs: "55%", md: "60%" },
                maxWidth: 260,
                objectFit: "contain",
                filter: "drop-shadow(0px 4px 8px rgba(0,0,0,0.15))",
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* ------------------------------------------------ */}
      {/*   EXISTING FOOTER (dark blue section)             */}
      {/* ------------------------------------------------ */}
      <Box
        component="footer"
        sx={{
          backgroundColor: '#12336e',
          color: '#ffffffff',
          borderTop: '1px solid #e2e8f0',
          px: 3,
          pt: 4,
          pb: 6,
          mt: 0, // remove gap since contact section is above
        }}
      >
        {/* Policy Links */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          spacing={2}
          flexWrap="wrap"
        >
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            © {new Date().getFullYear()} Work Horse, Singapore. All rights reserved.
          </Typography>

          <Stack direction="row" spacing={2} flexWrap="wrap">
            <Link href="/Terms" underline="hover" color="inherit">Terms of Service</Link>
            <Divider orientation="vertical" flexItem />
            <Link href="/Privacy" underline="hover" color="inherit">Privacy Policy</Link>
            <Divider orientation="vertical" flexItem />
            <Link href="/contact-us" underline="hover" color="inherit">Contact Us</Link>
          </Stack>
        </Stack>

        {/* Description + CTA */}
        <Box mt={4} textAlign="center">
          <Typography
            variant="body2"
            color="white"
            sx={{
              maxWidth: 900,
              mx: 'auto',
              mb: 2,
              lineHeight: 1.7,
            }}
          >
            Work Horse is Singapore’s leading platform for commercial vehicle listings including sedans, SUVs, vans, trucks and hybrid models. Buy from trusted dealers or direct sellers, explore vehicle services, and stay up-to-date with COE trends and automotive insights.
          </Typography>

          <Box mt={2}>
            <Link
              href="/vehicle-listing"
              underline="none"
              sx={{
                display: 'inline-block',
                backgroundColor: '#0f172a',
                color: '#fff',
                px: 3,
                py: 1,
                borderRadius: 1,
                fontWeight: 600,
                fontSize: '0.9rem',
                '&:hover': {
                  backgroundColor: '#facc15',
                  color: '#000',
                },
              }}
            >
              Browse Vehicle Listings →
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
